<template>
    <div class="mt-2">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="text-start text-truncate">
                    <h5>
                        <i class="fa-solid fa-power-off"></i>
                        {{ $t('Host') }} {{ $t('downtimes.downtimes') }}
                    </h5>
                </b-col>

                <b-col class="text-end">
                    <b-button-group>

                        <b-button variant="success" size="sm" v-show="actionPermissionsAdd" @click="addDowntime">
                            <i class="fa-solid fa-plus"></i>
                            {{ $t('downtimes.add') }}
                        </b-button>
                        <button type="button" class="btn btn-light btn-sm" @click="refreshData">
                            <i class="fa-solid fa-arrows-rotate"
                               :class="{'fa-spin': loading}"></i>
                        </button>
                    </b-button-group>
                </b-col>
            </b-row>
            <b-card>
                <b-button-group class="w-100">
                    <button type="button"
                        :class="{ 'btn btn-primary': visible === 'tab1', 'btn btn-light': visible !== 'tab1' }"
                        @click="setTab('tab1')">
                        <i class="fa-solid fa-power-off"></i>
                        <p class="mb-1">{{ $t('downtimes.downtimes') }}</p>
                    </button>
                    <button type="button"
                        @click="setTab('tab2')"
                        :class="{ 'btn btn-primary': visible === 'tab2', 'btn btn-light': visible !== 'tab2' }">
                        <i class="fa-solid fa-clock-rotate-left fa-flip-horizontal ok"></i>
                        <p class="mb-1">{{ $t('downtimes.recurring') }}</p>
                    </button>
                </b-button-group>
            </b-card>
                <div v-show="visible === 'tab1'" class="mt-3">
                    <b-list-group>
                        <b-list-group-item>
                            <div class="row">
                                <div class="col">
                                    <b-button class="m-0 w-100" variant="primary"  @click="filter = !filter">
                                        <i class="fa-solid fa-filter"></i>
                                        {{ $t('Filter') }}
                                    </b-button>
                                </div>
                            </div>
                            <b-collapse v-model="filter" id="filter">

                                <div class="d-flex w-100 mt-2">
                                    <b-form-input v-model="hostnameFilter" :placeholder="$t('hostname')"></b-form-input>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <b-form-input v-model="commentFilter" :placeholder="$t('comment')"></b-form-input>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <b-form-input v-model="userFilter" :placeholder="$t('user')"></b-form-input>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <b-form-group class="w-100">
                                        <label>{{ $t('Start') }}</label>
                                        <b-form-input v-model="downtimeFrom"
                                                      type="datetime-local"></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <b-form-group class="w-100">
                                        <label>{{ $t('end') }}</label>
                                        <b-form-input v-model="downtimeTo"
                                                      type="datetime-local"></b-form-input>
                                    </b-form-group>
                                </div>

                                <b-form-group
                                    label-for="isRunning">
                                    <b-form-checkbox
                                        switch
                                        id="isRunning"
                                        v-model="isRunningFilter"
                                        name="isRunningDowntimeFilter"
                                    >
                                        {{ $t('filter.is-running') }}
                                    </b-form-checkbox>
                                </b-form-group>
                                <b-form-group
                                    label-for="wasNotCancelled">
                                    <b-form-checkbox
                                        switch
                                        id="wasNotCancelled"
                                        v-model="wasNotCancelledFilter"
                                        name="wasNotCancelledDowntimeFilter"
                                    >
                                        {{ $t('filter.was-not-cancelled') }}
                                    </b-form-checkbox>
                                </b-form-group>
                                <b-form-group
                                    label-for="wasCancelled">
                                    <b-form-checkbox
                                        switch
                                        id="wasCancelled"
                                        v-model="wasCancelledFilter"
                                        name="wasCancelledDowntimeFilter"
                                    >
                                        {{ $t('filter.was-cancelled') }}
                                    </b-form-checkbox>
                                </b-form-group>
                                <b-form-group
                                    label-for="hideExpired">
                                    <b-form-checkbox
                                        switch
                                        id="hideExpired"
                                        v-model="hideExpiredFilter"
                                        name="hideExpiredDowntimeFilter"
                                    >
                                        {{ $t('filter.hide-expired') }}
                                    </b-form-checkbox>
                                </b-form-group>

                                <div class="col">
                                    <b-button class="w-100" @click="resetDowntimeFilter" variant="outline-danger">
                                        {{ $t('filter.reset-filter') }}
                                    </b-button>
                                </div>
                            </b-collapse>
                        </b-list-group-item> <!-- Filter end -->
                    </b-list-group>

                    <!-- start new list -->
                    <b-list-group
                        v-for="hostDowntime in hostDowntimes.downtimes"
                        v-bind:key="hostDowntime.DowntimeHost.internalDowntimeId"
                        class="mt-2">

                        <div class="flex-column align-items-start">
                            <div class="list-group-item flex-column align-items-start list-group-item-action ps-0">

                                <div class="d-flex flex-row min-h-110">
                                    <div class="p-2">
                                        <Downtime-State v-bind:downtime="hostDowntime.DowntimeHost"></Downtime-State>
                                    </div>
                                    <div class="min-width-0">
                                        <div class="row">
                                            <div class="col-12 text-end">
                                                <span
                                                    v-show="hostDowntime.DowntimeHost.isRunning"
                                                    class="font-italic downtime-running">
                                                    <i class="fa-solid fa-play"></i>
                                                    {{ $t('Running') }}
                                                </span>

                                                <span
                                                    v-show="hostDowntime.DowntimeHost.isExpired"
                                                    class="font-italic downtime-expired">
                                                    <i class="fa-solid fa-stop"></i>
                                                    {{ $t('Expired') }}
                                                </span>

                                                <span
                                                    v-show="hostDowntime.DowntimeHost.wasCancelled"
                                                    class="font-italic downtime-cancelled">
                                                    <i class="fa-solid fa-ban"></i>
                                                    {{ $t('Was cancelled') }}
                                                </span>

                                                <span
                                                    v-show="!hostDowntime.DowntimeHost.wasCancelled && !hostDowntime.DowntimeHost.wasStarted && !hostDowntime.DowntimeHost.isExpired"
                                                    class="font-italic downtime-upcoming">
                                                    <i class="fa-regular fa-clock"></i>
                                                    {{ $t('Upcoming') }}
                                                </span>

                                            </div>
                                        </div>
                                        <div class="row p-2">
                                            <div class="col-12 text-truncate h5">
                                                <router-link
                                                    class="link-underline link-underline-opacity-0"
                                                    :to="{name: 'hostsDetails', params: {id: hostDowntime.Host.id}}">
                                                    {{ hostDowntime.Host.hostname }}
                                                </router-link>
                                            </div>
                                            <div class="col-12 text-truncate">
                                                <div class="row">
                                                    <div class="col-12 text-truncate">
                                                        <i class="fa-solid fa-comment-dots"></i>
                                                        {{ hostDowntime.DowntimeHost.commentData }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 text-truncate pt-1"
                                                 v-show="hostDowntime.DowntimeHost.isRunning">
                                                {{ $t('Until') }}:
                                                {{ hostDowntime.DowntimeHost.scheduledEndTime }}
                                                <br/>
                                                {{ $t('Duration') }}:
                                                {{ hostDowntime.DowntimeHost.durationHuman }}
                                            </div>

                                            <div class="col-12 text-truncate pt-1"
                                                 v-show="hostDowntime.DowntimeHost.isExpired">
                                                {{ $t('Ended') }}:
                                                {{ hostDowntime.DowntimeHost.scheduledEndTime }}
                                            </div>

                                            <div class="col-12 text-truncate pt-1"
                                                 v-show="hostDowntime.DowntimeHost.wasCancelled">
                                                {{ $t('Cancelled') }}:
                                                {{ hostDowntime.DowntimeHost.actualEndTime }}
                                            </div>

                                            <div class="col-12 text-truncate pt-1"
                                                 v-show="!hostDowntime.DowntimeHost.wasCancelled && !hostDowntime.DowntimeHost.wasStarted && !hostDowntime.DowntimeHost.isExpired">
                                                {{ $t('Scheduled') }}:
                                                {{ hostDowntime.DowntimeHost.scheduledStartTime }}
                                                <br/>
                                                {{ $t('Duration') }}:
                                                {{ hostDowntime.DowntimeHost.durationHuman }}
                                            </div>

                                        </div>

                                        <div class="row"
                                             v-show="actionPermissionsDelete && hostDowntime.DowntimeHost.allowEdit && hostDowntime.DowntimeHost.isCancellable">
                                            <div class="col-12 text-end">
                                                <b-button
                                                    v-on:click="selectDowntime(hostDowntime)"
                                                    v-b-modal.cancelDowntimeModal
                                                    size="sm"
                                                    variant="outline-danger">
                                                    <i class="fa-solid fa-trash"></i>
                                                    {{ $t('Cancel') }}
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-list-group>
                    <!-- end new list -->

                    <b-list-group class="mt-3">
                        <div v-if="hostDowntimes.downtimes.length > 0">
                            <div class="d-flex w-100 justify-content-between">
                                <small>{{ $t('page') }} {{ paging.page }}</small>
                                <small>{{ $t('pagesize') }} {{ paging.limit }}</small>
                            </div>
                            <div class="d-flex w-100 justify-content-center mt-4">
                                <vue-awesome-paginate
                                    :total-items="paging.count"
                                    :items-per-page="25"
                                    :max-pages-shown="5"
                                    v-model="paging.page"
                                    :on-click="getDowntimes"
                                />

                            </div>
                        </div>
                        <b-list-group-item v-if="hostDowntimes.downtimes.length === 0">
                            <h5 class="mb-1">{{ $t('noitems') }}</h5>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <!-- host downtimes END -->
                <div v-show="visible === 'tab2'" class="mt-3">
                    <b-list-group>
                        <b-list-group-item>
                            <div class="row">
                                <div class="col">
                                    <b-button class="m-0 w-100" variant="primary"  @click="recfilter = !recfilter">
                                        <i class="fa-solid fa-filter"></i>
                                        {{ $t('Filter') }}
                                    </b-button>
                                </div>
                            </div>
                            <b-collapse v-model="recfilter">
                                <div class="d-flex w-100 mt-2">
                                    <b-form-input v-model="hostnameRecurringFilter"
                                                  :placeholder="$t('hostname')"></b-form-input>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <b-form-input v-model="commentRecurringFilter"
                                                  :placeholder="$t('comment')"></b-form-input>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <b-form-input v-model="userRecurringFilter"
                                                  :placeholder="$t('user')"></b-form-input>
                                </div>

                                <div class="col mt-2">
                                    <b-button class="w-100" @click="resetRecurringFilter" variant="outline-danger">
                                        {{ $t('filter.reset-filter') }}
                                    </b-button>
                                </div>
                            </b-collapse>
                        </b-list-group-item> <!-- Filter recurring end -->
                    </b-list-group>

                    <!-- start new recurring list -->
                    <b-list-group
                        v-for="recurringHostDowntime in hostDowntimes.recurring"
                        v-bind:key="recurringHostDowntime.Systemdowntime.id"
                        downtime="recurringHostDowntime"
                        v-on:click="selectDowntime(recurringHostDowntime)"
                        class="mt-2">

                        <div class="flex-column align-items-start">
                            <div class="list-group-item flex-column align-items-start list-group-item-action ps-0">

                                <div class="d-flex flex-row min-h-110">
                                    <div class="p-2">
                                        <div class="h-100 status-line bg-info shadow-info"></div>
                                    </div>
                                    <div class="min-width-0">
                                        <div class="row">
                                            <div class="col-12 text-end">

                                                <span
                                                    class="font-italic text-info">
                                                    {{ $t('Recurring') }}</span>

                                            </div>
                                        </div>
                                        <div class="row p-2">
                                            <div class="col-12 text-truncate h5">
                                                <router-link
                                                    :to="{name: 'hostsDetails', params: {id: recurringHostDowntime.Host.id}}">
                                                    {{ recurringHostDowntime.Host.hostname }}
                                                </router-link>
                                            </div>
                                            <div class="col-12 text-truncate">
                                                <div class="row">
                                                    <div class="col-12 text-truncate">
                                                        <i class="fa-solid fa-comment-dots"></i>
                                                        {{ recurringHostDowntime.Systemdowntime.comment }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 text-truncate pt-1">
                                                {{ $t('Start') }}:
                                                {{ recurringHostDowntime.Systemdowntime.startTime }}
                                                <br/>
                                                {{ $t('Duration') }}:
                                                {{ recurringHostDowntime.Systemdowntime.duration }}
                                                {{ $t('minutes') }}
                                                <br/>
                                                {{ $t('Creator') }}:
                                                {{ recurringHostDowntime.Systemdowntime.author }}
                                            </div>

                                        </div>

                                        <div class="row"
                                             v-show="actionPermissionsDelete && recurringHostDowntime.Host.allow_edit">
                                            <div class="col-12 text-end">
                                                <b-button
                                                    v-on:click="selectDowntime(recurringHostDowntime)"
                                                    v-b-modal.recurringDowntimeModal
                                                    size="sm"
                                                    variant="outline-danger">
                                                    <i class="fa-solid fa-trash"></i>
                                                    {{ $t('Delete') }}
                                                </b-button>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </b-list-group>
                    <!-- end new recurring list -->

                    <b-list-group class="mt-3">
                        <div v-if="hostDowntimes.recurring.length > 0">
                            <div class="d-flex w-100 justify-content-between">
                                <small>{{ $t('page') }} {{ recurringPaging.page }}</small>
                                <small>{{ $t('pagesize') }} {{ recurringPaging.limit }}</small>
                            </div>
                            <div class="d-flex w-100 justify-content-center mt-4">
                                <div class="d-flex w-100 justify-content-center mt-4">
                                    <vue-awesome-paginate
                                        :total-items="recurringPaging.count"
                                        :items-per-page="25"
                                        :max-pages-shown="5"
                                        v-model="recurringPaging.page"
                                        :on-click="getDowntimes"
                                    />
                                </div>
                            </div>
                        </div>
                        <b-list-group-item v-if="hostDowntimes.recurring.length === 0">
                            <h5 class="mb-1">{{ $t('noitems') }}</h5>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <!-- Recurring host downtimes END -->
            <!-- Cancel downtime modal START -->
            <div>
                <b-modal hide-footer
                    id="cancelDowntimeModal"
                    ref="cancelDowntimeModal"
                    :title="$t('forms.attention')"
                    header-bg-variant="danger"
                    header-text-variant="white">
                    <h6 class="text-danger">{{ $t('downtimes.confirm-cancel-downtime-host') }}</h6>

                    <div v-if="selectedDowntime.Host != null && selectedDowntime.DowntimeHost != null">

                        <dl>
                            <dt>{{ $t('Hostname') }}</dt>
                            <dd class="text-truncate">
                                <router-link :to="{name: 'hostsDetails', params: {id: selectedDowntime.Host.id}}">
                                    {{ selectedDowntime.Host.hostname }}
                                </router-link>
                            </dd>

                            <dt>{{ $t('User') }}</dt>
                            <dd class="text-truncate">{{ selectedDowntime.DowntimeHost.authorName }}</dd>

                            <dt>{{ $t('comment') }}</dt>
                            <dd class="text-truncate">{{ selectedDowntime.DowntimeHost.commentData }}</dd>

                            <dt>{{ $t('Start') }}</dt>
                            <dd>{{ selectedDowntime.DowntimeHost.scheduledStartTime }}</dd>

                            <dt>{{ $t('End') }}</dt>
                            <dd>{{ selectedDowntime.DowntimeHost.scheduledEndTime }}</dd>

                            <dt>{{ $t('duration') }}</dt>
                            <dd>{{ selectedDowntime.DowntimeHost.durationHuman }}</dd>
                        </dl>

                    </div>
                    <hr>
                    <b-form-group
                        :description="$t('This will also remove all current Service downtimes from this host')"
                        label-for="removeHostServiceDowntimes">
                        <b-form-checkbox
                            switch
                            id="removeHostServiceDowntime"
                            v-model="includeServices"
                            name="hostServiceDowntimesCheckbox">
                            {{ $t('forms.remove-service-downtimes') }}
                        </b-form-checkbox>
                    </b-form-group>

                    <div class="row">
                        <div class="col">
                            <b-button class="float-start" size="sm" variant="danger" @click="cancelDowntime();"
                                      v-show="actionPermissionsSystemDelete">
                                <i class="fa-solid fa-trash"></i>
                                {{ $t('cancel-downtime') }}
                            </b-button>
                        </div>
                        <div class="col">
                            <b-button size="sm" variant="secondary" class="float-end" @click="cancel()">
                                {{ $t('forms.close') }}
                            </b-button>
                        </div>
                    </div>
                </b-modal>
            </div>
            <!-- Cancel downtime modal END -->

            <!-- Recurring downtime modal START -->
            <div>
                <b-modal hide-footer
                    id="recurringDowntimeModal"
                    header-bg-variant="info"
                    header-text-variant="white"
                    ref="recurringDowntimeModal"
                    :title="$t('Recurring downtime Info')">
                    <div v-if="selectedDowntime.Systemdowntime != null">
                        <dl>
                            <dt>{{ $t('Hostname') }}</dt>
                            <dd class="text-truncate">
                                <router-link :to="{name: 'hostsDetails', params: {id: selectedDowntime.Host.id}}">
                                    {{ selectedDowntime.Host.hostname }}
                                </router-link>
                            </dd>

                            <dt class="text-truncate">{{ $t('User') }}</dt>
                            <dd>{{ selectedDowntime.Systemdowntime.author }}</dd>

                            <dt class="text-truncate">{{ $t('comment') }}</dt>
                            <dd>{{ selectedDowntime.Systemdowntime.comment }}</dd>

                            <dt>{{ $t('forms.weekdays') }}</dt>
                            <dd>
                                <b-badge class="me-1" :variant="getSelectedWeekdays(selectedDowntime.Systemdowntime.weekdays, '1')">
                                    {{ $t('days.monday') }}
                                </b-badge>
                                <b-badge class="me-1" :variant="getSelectedWeekdays(selectedDowntime.Systemdowntime.weekdays, '2')">
                                    {{ $t('days.tuesday') }}
                                </b-badge>
                                <b-badge class="me-1" :variant="getSelectedWeekdays(selectedDowntime.Systemdowntime.weekdays, '3')">
                                    {{ $t('days.wednesday') }}
                                </b-badge>
                                <b-badge class="me-1" :variant="getSelectedWeekdays(selectedDowntime.Systemdowntime.weekdays, '4')">
                                    {{ $t('days.thursday') }}
                                </b-badge>
                                <b-badge class="me-1" :variant="getSelectedWeekdays(selectedDowntime.Systemdowntime.weekdays, '5')">
                                    {{ $t('days.friday') }}
                                </b-badge>
                                <b-badge class="me-1" :variant="getSelectedWeekdays(selectedDowntime.Systemdowntime.weekdays, '6')">
                                    {{ $t('days.saturday') }}
                                </b-badge>
                                <b-badge :variant="getSelectedWeekdays(selectedDowntime.Systemdowntime.weekdays, '7')">
                                    {{ $t('days.sunday') }}
                                </b-badge>
                            </dd>

                            <dt>{{ $t('forms.monthdays') }}</dt>
                            <dd>
                                <b-badge v-for="(dayOfMonthItem, index) in selectedDowntime.Systemdowntime.dayOfMonth"
                                         :key="index"
                                         :variant="'success'"
                                         class="me-1">{{ dayOfMonthItem }}
                                </b-badge>
                                <span v-if="selectedDowntime.Systemdowntime.dayOfMonth.length === 0" class="font-italic">
                                    {{ $t('none') }}
                                </span>
                            </dd>

                            <dt>{{ $t('Start') }}</dt>
                            <dd>{{ selectedDowntime.Systemdowntime.startTime }} {{ $t('minutes') }}</dd>

                            <dt>{{ $t('duration') }}</dt>
                            <dd>{{ selectedDowntime.Systemdowntime.duration }} {{ $t('minutes') }}</dd>
                        </dl>

                    </div>
                    <hr>
                    <b-form-group
                        :description="$t('This will also remove all current Service downtimes from this host')"
                        label-for="removeHostServiceDowntimes">
                        <b-form-checkbox
                            switch
                            id="removeHostServiceDowntime"
                            v-model="includeServices"
                            name="hostServiceDowntimesCheckbox">
                            {{ $t('forms.remove-service-downtimes') }}
                        </b-form-checkbox>
                    </b-form-group>
                    <div class="row">
                        <div class="col">
                            <b-button class="float-start" size="sm" variant="danger" @click="cancelDowntime()"
                                      v-show="actionPermissionsSystemDelete">
                                <i class="fa-solid fa-trash"></i>
                                {{ $t('cancel-downtime') }}
                            </b-button>
                        </div>
                        <div class="col">
                            <b-button class="float-end" size="sm" variant="secondary" @click="cancelrec()">
                                {{ $t('forms.close') }}
                            </b-button>
                        </div>
                    </div>
                </b-modal>
            </div>
            <!-- Recurring downtime modal END -->
        </b-container>
    </div>
</template>

<script>
import {debounce} from "../../helpers";
import DowntimeState from "../utils/DowntimeState";
import {VueAwesomePaginate} from "vue-awesome-paginate";
import { useToast } from "vue-toastification";
import { BModal } from 'bootstrap-vue-next';

export default {
    name: "DowntimesHosts",
    components: {BModal, VueAwesomePaginate, DowntimeState},
    data(){
        let now = new Date();
        let from = new Date(now.getTime() - (3600 * 24 * 30 * 1000));
        let to = new Date(now.getTime() + (3600 * 24 * 30 * 2 * 1000));
        return {
            visible: 'tab1',
            filter: false,
            recfilter: false,
            init: false,
            loading: true,
            hostDowntimes: {
                downtimes: [],
                recurring: []
            },
            selectedDowntime: {},
            includeServices: false,
            paging: {
                page: 1,
                pageCount: 1,
                count: 0
            },
            recurringPaging: {
                page: 1,
                pageCount: 1,
                count: 0
            },
            downtimeFilter: {
                filter: {
                    hideExpired: true,
                    isRunning: '',
                    was_cancelled: '',
                    authorName: '',
                    commentData: '',
                    hostname: '',
                    from: from.toLocaleString('de-DE', {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit"
                    }).replace(',', ''),
                    to: to.toLocaleString('de-DE', {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit"
                    }).replace(',', '')
                }
            },
            hostnameFilter: '',
            commentFilter: '',
            userFilter: '',
            downtimeFrom: '',
            downtimeTo: '',
            isRunningFilter: '',
            hideExpiredFilter: true,
            wasCancelledFilter: false,
            wasNotCancelledFilter: '',
            hostnameRecurringFilter: '',
            commentRecurringFilter: '',
            userRecurringFilter: '',
            recurringFilter: {
                filter: {
                    hostname: '',
                    author: '',
                    comment: ''
                }
            },
            permissions: {
                downtimes: {},
                systemdowntimes: {}
            }
        };
    },
    methods: {
        setTab: function (val) {
            this.visible = val;
            if (val === 'tab1') {
                this.getDowntimes(this.paging.page)
            }
            if (val === 'tab2') {
                this.getRecurringDowntimes(this.recurringPaging.page)
            }
        },
        selectDowntime: function(hostDowntime){
            this.selectedDowntime = hostDowntime;
        },
        cancel: function(){
            this.$refs.cancelDowntimeModal.hide();
        },
        cancelrec: function(){
            this.$refs.recurringDowntimeModal.hide();
        },
        cancelDowntime: function(){
            let downtimeId = null;
            let downtimeType = null;
            if(this.selectedDowntime.hasOwnProperty('Systemdowntime')){
                //recurring downtime
                downtimeId = this.selectedDowntime.Systemdowntime.id;
                downtimeType = 'Systemdowntime';
            }else{
                //normal downtime
                downtimeId = this.selectedDowntime.DowntimeHost.internalDowntimeId;
                downtimeType = 'downtime';
            }

            axios.post('/downtimes/delete.json',
                {
                    downtimeType: downtimeType,
                    downtimeId: downtimeId,
                    includeServices: this.includeServices
                })
                .then(response => {
                        if(response.data.response.hasOwnProperty('error')){
                            useToast().error(this.$t('error'), {
                                timeout: 2000
                            });
                            return;
                        }
                        useToast().success(this.$t('Downtime successfully cancelled'), {
                            timeout: 7000
                         });
                        if(downtimeType === 'downtime'){
                            this.$refs['cancelDowntimeModal'].hide()
                            setTimeout(() => {
                                this.getDowntimes(1)
                            }, 7000);

                        }
                        if(downtimeType === 'Systemdowntime'){
                            this.$refs['recurringDowntimeModal'].hide()
                            setTimeout(() => {
                                this.getRecurringDowntimes(1)
                            }, 7000);
                        }
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
        getSelectedWeekdays: function(weekdays, WeekdayId){
            if(weekdays.includes(WeekdayId)){
                return 'success';
            }
            return 'secondary';
        },

        triggerDowntimes: function(){
            if(this.init === true){
                this.getDowntimes(1);
            }
        },

        getDowntimes(page){
            let loader = this.$loading.show();
            this.loading = true;
            axios.post('/downtimes/hosts.json', {
                filter: this.downtimeFilter,
                page: page
            }, {
                params: {}
            }).then(response => {
                    this.hostDowntimes.downtimes = response.data.hostDowntimes['all_host_downtimes'] ?? [];
                    this.paging = response.data.hostDowntimes['paging'] ?? {page: 1, pageCount: 1};
                    this.permissions.downtimes = response.data.permissions.downtimes ?? {};
                    this.permissions.systemdowntimes = response.data.permissions.systemdowntimes ?? {};
            })
            .catch(error => {
                useToast().error(this.$t('error'), {
                    timeout: 2000
                });
            })
            .finally(() => {
                this.loading = false;
                loader.hide();
            });
        },

        resetDowntimeFilter: function(){
            this.init = false;
            this.getDateTime();
            this.downtimeFilter = {
                filter: {
                    hideExpired: true,
                    isRunning: '',
                    was_cancelled: '',
                    authorName: '',
                    commentData: '',
                    hostname: '',
                    from: new Date(new Date().getTime() - (3600 * 24 * 30 * 1000)).toLocaleString('de-DE').slice(0, 16).replace(',', ''),
                    to: new Date(new Date().getTime() + (3600 * 24 * 30 * 2000)).toLocaleString('de-DE').slice(0, 16).replace(',', '')
                }
            };

            this.hideExpiredFilter = true;
            this.isRunningFilter = '';
            this.wasCancelledFilter = false;
            this.commentFilter = null;
            this.userFilter = null;
            this.hostnameFilter = null;

            this.getDowntimes(1);
            let scope = this;
            setTimeout(function(){
                scope.init = true;
            }, 1500);
        },
        resetRecurringFilter: function(){
            this.recurringFilter = {
                filter: {
                    hostname: '',
                    author: '',
                    comment: ''
                }
            };
            this.commentRecurringFilter = null;
            this.userRecurringFilter = null;
            this.hostnameRecurringFilter = null;
            this.getRecurringDowntimes(1);
        },
        getDateTime(){
            axios.post('/downtimes/get_dates.json', null, {
                params: {
                    startOffset: -(3600 * 24 * 30),
                    endOffset: (3600 * 24 * 30 * 2)
                }
            })
                .then(response => {
                        let datetime = response.data.datetime[0];
                        this.downtimeFrom = datetime.start_time;
                        this.downtimeTo = datetime.end_time;
                })
                .catch(error => {
                    console.log('Error: ' + error)
                });
        },
        convertDateTime: function(datetimeString){
            let date = new Date(datetimeString);
            let formattedDate = new Intl.DateTimeFormat('de-DE', {
                dateStyle: 'medium',
                timeStyle: 'short'
            }).format(date);
            formattedDate = formattedDate.replace(',', '');
            return formattedDate;
        },
        getRecurringDowntimes(page){
            let loader = this.$loading.show();
            axios.post('/downtimes/hosts_recurring.json', {
                page: page,
                filter: this.recurringFilter
            }, {
                params: {}
            }).then(response => {
                    this.hostDowntimes.recurring = response.data.hostDowntimes['all_host_recurring_downtimes'] ?? [];
                    this.recurringPaging = response.data.hostDowntimes['paging'] ?? {page: 1, pageCount: 1};
            })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
        },
        refreshData: function(){
            this.resetDowntimeFilter();
            this.getDowntimes(this.paging.page);
        },
        addDowntime: function(){
            this.$router.push({ name: 'downtimesHostAdd'});
        },
    },
    mounted(){
        this.getDateTime();
        if (!this.$route.params.triggerRefresh) {
            this.getDowntimes(this.paging.page);
        }
        //this.getDowntimes(this.paging.page)
        let scope = this;
        setTimeout(function(){
            scope.init = true;
        }, 1500);

        if (this.$route.params.triggerRefresh) {
            this.visible = this.$route.params.triggerRefresh;
            if(this.$route.params.triggerRefresh === 'tab1'){
                setTimeout(function () {
                    this.visible = 'tab1';
                    this.resetDowntimeFilter();
                    this.getDowntimes(1);
                }.bind(this), 5000);
            }
            if(this.$route.params.triggerRefresh === 'tab2'){
                setTimeout(function () {
                    this.visible = 'tab2';
                    this.resetRecurringFilter();
                    this.getDowntimes(1);
                    this.getRecurringDowntimes(1);
                }.bind(this), 5000);
            }
        }

    },
    watch: {
        hostnameFilter: debounce(function(newValue){
            if(newValue != null){
                this.downtimeFilter.filter.hostname = newValue;
                this.triggerDowntimes();
            }
        }, 700),
        commentFilter: debounce(function(newValue){
            if(newValue != null){
                this.downtimeFilter.filter.commentData = newValue;
                this.triggerDowntimes();
            }
        }, 700),
        userFilter: debounce(function(newValue){
            if(newValue != null){
                this.downtimeFilter.filter.authorName = newValue;
                this.triggerDowntimes();
            }
        }, 700),
        isRunningFilter: debounce(function(newValue){
            if(newValue != null){
                this.downtimeFilter.filter.isRunning = newValue;
                this.triggerDowntimes();
            }
        }, 700),

        hideExpiredFilter: debounce(function(newValue){
            if(newValue != null){
                this.downtimeFilter.filter.hideExpired = newValue;
                this.triggerDowntimes();
            }
        }, 700),

        wasCancelledFilter: debounce(function(newValue){
            if(newValue != null){
                if(newValue === false){
                    if(this.wasNotCancelledFilter === false){
                        this.downtimeFilter.filter.was_cancelled = '';
                    }else{
                        this.downtimeFilter.filter.was_cancelled = false;
                    }
                }else{
                    if(this.wasNotCancelledFilter === true){
                        this.downtimeFilter.filter.was_cancelled = '';
                    }else{
                        this.downtimeFilter.filter.was_cancelled = true;
                    }
                }
                this.triggerDowntimes();
            }
        }, 700),
        wasNotCancelledFilter: debounce(function(newValue){
            if(newValue != null){
                if(newValue === false){
                    if(this.wasCancelledFilter === false){
                        this.downtimeFilter.filter.was_cancelled = '';
                    }else{
                        this.downtimeFilter.filter.was_cancelled = true;
                    }
                }else{
                    if(this.wasCancelledFilter === false){
                        this.downtimeFilter.filter.was_cancelled = false;
                    }else{
                        this.downtimeFilter.filter.was_cancelled = '';
                    }
                }
                this.triggerDowntimes();
            }
        }, 700),
        downtimeFrom: debounce(function(newValue){
            if(newValue != null){
                if(newValue === ''){
                    this.downtimeFilter.filter.from = new Date(new Date().getTime() - (3600 * 24 * 30 * 1000)).toLocaleString('de-DE').slice(0, 16).replace(',', '');
                }else{
                    this.downtimeFilter.filter.from = this.convertDateTime(newValue);

                }
                this.triggerDowntimes();
            }
        }, 700),
        downtimeTo: debounce(function(newValue){
            if(newValue != null && newValue !== ''){
                if(newValue === ''){
                    this.downtimeFilter.filter.to = new Date(new Date().getTime() + (3600 * 24 * 30 * 2000)).toLocaleString('de-DE').slice(0, 16).replace(',', '');
                }else{
                    this.downtimeFilter.filter.to = this.convertDateTime(newValue);
                }
                this.triggerDowntimes();

            }
        }, 700),

        /*
         * Recurring downtimes filter
         */
        hostnameRecurringFilter: debounce(function(newValue){
            if(newValue != null){
                this.recurringFilter.filter.hostname = newValue;
                this.getRecurringDowntimes(1);
            }
        }, 700),
        commentRecurringFilter: debounce(function(newValue){
            if(newValue != null){
                this.recurringFilter.filter.comment = newValue;
                this.getRecurringDowntimes(1);
            }
        }, 700),
        userRecurringFilter: debounce(function(newValue){
            if(newValue != null){
                this.recurringFilter.filter.author = newValue;
                this.getRecurringDowntimes(1);
            }
        }, 700),
    },
    computed: {
        actionPermissionsAdd: function(){
            return this.permissions.systemdowntimes.hasOwnProperty('addhostdowntime');
        },
        actionPermissionsDelete: function(){
            return this.permissions.downtimes.hasOwnProperty('delete');
        },
        actionPermissionsSystemDelete: function(){
            return this.permissions.systemdowntimes.hasOwnProperty('delete');
        },
    },
}
</script>

<style scoped>

</style>
